export enum FILTER_TYPES {
  CATEGORY = "category",
  PRICE = "price",
  SIZE = "size",
  MULTI_SELECT = "multiSelect",
  SINGLE_SELECT = "singleSelect",
  MORE_FILTERS = "moreFilters"
}

export enum FILTER_QUERY_PARAMS {
  SORT = "sort",
  SIZE = "size"
}

export const CATEGORY_QUERY_PARAMS = ["p_cat", "cat", "sub_cat"] as const;
